<template>
    <NuxtLayout name="malt-base-layout">
        <main>
            <VJoyFunnel :hide-shapes="true" class="registration" layout-width="medium">
                <template #funnel-header>
                    <VJoyFunnelHeader>
                        <template #funnel-header-left>
                            <slot name="header-left">
                                <a class="registration__malt-logo" href="/" :title="$t('registration.header.malt.logo.title')">
                                    <MaltImg
                                        src="/navbar/logos/malt-logo-red.svg?vh=9690b2"
                                        :alt="$t('registration.header.malt.logo.title')"
                                        height="28"
                                    />
                                </a>
                            </slot>
                        </template>
                        <template #funnel-header-right>
                            <slot name="header-right"></slot>
                        </template>
                    </VJoyFunnelHeader>
                </template>
                <VJoyTemplate>
                    <template #template-main>
                        <slot />
                        <VJoyFunnelFooter v-if="$slots['footer-left'] || $slots['footer-right']">
                            <template #footer-left>
                                <slot name="footer-left" />
                            </template>
                            <template #footer-right>
                                <slot name="footer-right" />
                            </template>
                        </VJoyFunnelFooter>
                    </template>
                </VJoyTemplate>
            </VJoyFunnel>
        </main>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {VJoyFunnel, VJoyFunnelHeader, VJoyTemplate, VJoyFunnelFooter} from '@maltjoy/core-vue';
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .registration {
        &.joy-funnel {
            background-color: var(--joy-color-neutral-10);
        }

        &__malt-logo {
            height: 40px;

            img {
                height: 28px;
            }
        }

        &__go-back {
            cursor: pointer;
        }
    }
</style>
